/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useEffect, useRef, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import GetAppIcon from '@material-ui/icons/GetApp';
import { getMaternityLicenceDocuments, getMaternityLicenceDocumentById } from "../../actions/licence-motherhood-actions";
import { Grid } from "@material-ui/core";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";

const PregnantDocumentsModal = (props) => {
  const {
    handleClose,
    open,
    licenceId
  } = props;
  const [documents, setDocuments] = useState([]);
  const [documentName, setDocumentName] = useState("");

  useEffect(() => {
    const getDocuments = async () => {
      const response = await getMaternityLicenceDocuments(licenceId);
      setDocuments(response.data);
    };
    getDocuments();
  }, [licenceId]);

  function downloadExam(pdf) {
    const format = pdf?.format.toLowerCase();
    const formatPdf = format === 'pdf' || format === 'application/pdf'
      ? 'pdf'
      : format === 'image/jpeg' || format === 'jpeg'
        ? 'jpeg'
        : format === 'image/png' || format === 'png'
          ? 'png'
          : 'jpg'
    const url = `data:@file/${formatPdf};base64,${pdf?.data}`;
    const downloadLink = document.createElement("a");
    const fileName = `${pdf?.name ?? 'file'}`;

    downloadLink.href = url;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  const [showMessage, setShowMessage] = useState(false);

  const handleClickClose = () => {
    setShowMessage(false);
  };

  const [message, setMessage] = useState({
    description: '',
    textButtonSubmit: '',
    handleClick: () => handleClickClose(),
    oneButtons: true,
    type: 'WARNING',
    open: false
  });

  const returnMessageError = (response, msj) => {
    setMessage({
      description: response?.data?.detail
        ? response?.data.detail
        : msj,
      textButtonSubmit: "Aceptar",
      handleClick: () => handleClickClose(),
      type: "WARNING",
      threeButtons: false,
      oneButtons: true,
      open: true,
    });
  }


  const handleDownloadFile = (documentId, licenceId, fileType) => {
    const getLicenceDocumentByIdAsync = async () => {
      const contractResponse = await getMaternityLicenceDocumentById(licenceId, documentId);
      if (contractResponse?.status === 200 || contractResponse?.status === 201) {
        if (contractResponse?.data?.data) {
          downloadExam(contractResponse?.data);
        } else {
          const msj = 'Ocurrió un error procesando la solicitud, inténtelo nuevamentes'
          returnMessageError(contractResponse, msj);
        }
      } else {
        const msj = 'Ocurrió un error procesando la solicitud, inténtelo nuevamentes'
          returnMessageError(contractResponse, msj);
      }
    };
    getLicenceDocumentByIdAsync();
  };

  return (
    <div>
      <Dialog
        PaperProps={{
          style: { borderRadius: 16, padding: 30 },
        }}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ color: "#7EBDCE" }}>
          <div style={{ textAlign: "center" }}>
            
            <p>Documentos registro de embarazo</p>
          </div>
        </DialogTitle>
        <DialogContent >
          <Grid container spacing={1} >
            {documents && documents.map((doc) => (
              <>
                <Grid item xs={12} md={6} lg={6}>
                  {doc.name}
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <Button
                    onClick={() => handleDownloadFile(doc.saeDocumentId, doc.maternityLicenceId)}
                    style={{ color: "#7EBDCE", borderColor: "#E1E1E1" }}>
                      Descargar&nbsp;&nbsp;<GetAppIcon />  
                  </Button>
                </Grid>
              </>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions style={{ justifyContent: "space-around", marginTop:"10px" }}>
          <Button
            onClick={handleClose}
            color="primary"
            variant="outlined"
            style={{ color: "#7EBDCE", borderColor: "#E1E1E1" }}
          >
            Cancelar
          </Button>

        </DialogActions>
      </Dialog>
      {showMessage && <ModalConfirmBase
        description={message.description}
        textButtonSubmit={message.textButtonSubmit}
        handleClick={message.handleClick}
        handleClickOut={message.handleClickOut}
        oneButtons={message.oneButtons}
        type={message.type}
        open={showMessage}
      />}
    </div>
  );
};
export default PregnantDocumentsModal;
